<template>
   <div v-cloak class='nIndex'>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.title'></router-view>
      </keep-alive>
      <router-view v-wechat-title='$route.meta.title' v-if="!$route.meta.keepAlive"/>
   </div>
</template>
<script>
import { CacheModule } from '@/utils/commonUtils.js'
import { mutations } from "@/observable/store"
export default {
  name: 'index',
   data(){
        return {
           
        }
    },
    created(){
      if(CacheModule.get('setToken')){
        mutations.getToken(CacheModule.get('setToken'))  
      } 
    },
      methods: {
      goHome(){
          this.$router.push({
                path:'/',
            })
      },

      },
}
</script>
<style lang="less" scoped>
.nIndex{
  height:100%;
}
</style>
